"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.connectWallet = exports.loadWalletModule = void 0;
var ethers_1 = require("ethers");
var eventemitter3_1 = __importDefault(require("eventemitter3"));
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var onboard_common_1 = require("@sovryn/onboard-common");
var configuration_1 = require("./configuration");
var provider_1 = require("./provider");
var store_1 = require("./store");
var actions_1 = require("./store/actions");
var streams_1 = require("./streams");
var utils_1 = require("./utils");
function connect(wallet) {
    return __awaiter(this, void 0, void 0, function () {
        var chains, result$;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    chains = store_1.state.get().chains;
                    if (!chains.length) {
                        throw new Error('At least one chain must be set before attempting to connect a wallet');
                    }
                    if (!wallet) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, utils_1.wait)(50)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!store_1.state.get().walletModules.length) {
                        (0, actions_1.setWalletModules)(configuration_1.configuration.initialWalletInit);
                    }
                    streams_1.connectWallet$.next({
                        module: wallet,
                        inProgress: true
                    });
                    result$ = streams_1.connectWallet$.pipe((0, operators_1.filter)(function (_a) {
                        var inProgress = _a.inProgress, actionRequired = _a.actionRequired;
                        return inProgress === false && !actionRequired;
                    }), (0, operators_1.withLatestFrom)(streams_1.wallets$), (0, operators_1.map)(function (x) { return x === null || x === void 0 ? void 0 : x[1]; }));
                    return [2 /*return*/, (0, rxjs_1.firstValueFrom)(result$)];
            }
        });
    });
}
exports["default"] = connect;
var loadWalletModule = function (walletModule) { return __awaiter(void 0, void 0, void 0, function () {
    var existingWallet, error_1, code, chains, _a, provider, instance, loadedIcon, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 8, , 9]);
                existingWallet = store_1.state
                    .get()
                    .wallets.find(function (wallet) { return wallet.label === walletModule.label; });
                if (!existingWallet) return [3 /*break*/, 5];
                // set as first wallet
                (0, actions_1.addWallet)(existingWallet);
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, provider_1.requestAccounts)(existingWallet.provider)];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _b.sent();
                code = error_1.code;
                if (code === onboard_common_1.ProviderRpcErrorCode.UNSUPPORTED_METHOD ||
                    code === onboard_common_1.ProviderRpcErrorCode.DOES_NOT_EXIST) {
                    streams_1.connectWallet$.next({
                        inProgress: false,
                        actionRequired: existingWallet.label
                    });
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, existingWallet];
            case 5:
                chains = store_1.state.get().chains;
                return [4 /*yield*/, walletModule.getInterface({
                        chains: chains,
                        BigNumber: ethers_1.BigNumber,
                        EventEmitter: eventemitter3_1["default"],
                        appMetadata: null
                    })];
            case 6:
                _a = _b.sent(), provider = _a.provider, instance = _a.instance;
                return [4 /*yield*/, walletModule.getIcon()];
            case 7:
                loadedIcon = _b.sent();
                return [2 /*return*/, {
                        label: walletModule.label,
                        icon: loadedIcon,
                        provider: provider,
                        instance: instance,
                        accounts: [],
                        chains: [{ namespace: 'evm', id: '0x1' }]
                    }];
            case 8:
                error_2 = _b.sent();
                throw error_2;
            case 9: return [2 /*return*/];
        }
    });
}); };
exports.loadWalletModule = loadWalletModule;
var connectWallet = function (walletModule) { return __awaiter(void 0, void 0, void 0, function () {
    var selectedWallet, provider, label, address, chain, update, error_3, _a, code, message;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                streams_1.connectWallet$.next({
                    error: undefined,
                    inProgress: true
                });
                return [4 /*yield*/, (0, exports.loadWalletModule)(walletModule)];
            case 1:
                selectedWallet = _b.sent();
                provider = selectedWallet.provider, label = selectedWallet.label;
                return [4 /*yield*/, (0, provider_1.requestAccounts)(provider)];
            case 2:
                address = (_b.sent())[0];
                // canceled previous request
                if (!address) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, (0, provider_1.getChainId)(provider)];
            case 3:
                chain = _b.sent();
                update = {
                    accounts: [{ address: address }],
                    chains: [{ namespace: 'evm', id: chain }]
                };
                (0, actions_1.addWallet)(__assign(__assign({}, selectedWallet), update));
                (0, provider_1.trackWallet)(provider, label);
                streams_1.connectWallet$.next({
                    inProgress: false
                });
                return [3 /*break*/, 5];
            case 4:
                error_3 = _b.sent();
                _a = error_3, code = _a.code, message = _a.message;
                streams_1.connectWallet$.next({
                    error: message,
                    inProgress: true
                });
                // user rejected account access
                if (code === onboard_common_1.ProviderRpcErrorCode.ACCOUNT_ACCESS_REJECTED) {
                    // connectionRejected = true
                    // if (autoSelect.disableModals) {
                    //   connectWallet$.next({ inProgress: false })
                    // } else if (autoSelect.label) {
                    //   autoSelect.label = ''
                    // }
                    return [2 /*return*/];
                }
                // account access has already been requested and is awaiting approval
                if (code === onboard_common_1.ProviderRpcErrorCode.ACCOUNT_ACCESS_ALREADY_REQUESTED) {
                    return [2 /*return*/];
                }
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.connectWallet = connectWallet;
